module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.a43e3817.png";